import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import SEO from "@/components/seo/SEO";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nContext";
import { OCCASIONS } from "@/data/occasions";
import { LANDING } from "@/constants/testIds";

export default function OccasionLanding({ slug }) {
  const { t, language } = useI18n();
  const data = OCCASIONS[slug];
  const content = data[language] || data.fr;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: content.heroTitle,
    description: content.metaDescription,
    provider: { "@type": "Organization", name: "Kalypso Music" },
    areaServed: "Worldwide",
  };

  return (
    <div className="min-h-screen bg-background">
      <SEO title={content.metaTitle} description={content.metaDescription} path={data.path} jsonLd={jsonLd} />
      <Navbar />
      <main>
        <section className="px-4 py-24 sm:px-6 lg:px-8" data-testid={`occasion-hero-${slug}`}>
          <div className="mx-auto max-w-4xl text-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-sm text-primary">
              <Sparkles className="h-3.5 w-3.5" />
              {t("landing.badge")}
            </div>
            <h1 className="mt-6 font-heading text-4xl font-medium tracking-tight sm:text-5xl lg:text-6xl">{content.heroTitle}</h1>
            <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">{content.heroSubtitle}</p>
            <Link to="/create" className="mt-8 inline-block">
              <Button size="lg" className="rounded-full px-8" data-testid={LANDING.heroCta}>
                {t("landing.heroCta")}
              </Button>
            </Link>
          </div>
        </section>
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
